import { BeneficiaryFilterItem } from '@repo/shared/dtos/beneficiary'
import { StructuredDataSchemaItem } from '@repo/shared/dtos/structured-data'
import { Popover, PopoverContent, PopoverTrigger } from '@repo/ui/popover'
import { useState } from 'react'

import MultiselectFilterForm from '@/components/beneficiary/list/filters/MultiselectFilterForm'

import BooleanFilterForm from './BooleanFilterForm'
import DateFilterForm from './DateFilterForm'
import EnumFilterForm from './EnumFilterForm'
import {
  buildBooleanFilter,
  buildDateFilter,
  buildEnumFilter,
  buildMultiselectFilter,
  buildNumberFilter,
  buildStringFilter,
} from './helpers'
import NumberFilterForm from './NumberFilterForm'
import StringFilterForm from './StringFilterForm'

type NewFilterFormProps = {
  schemaItem: StructuredDataSchemaItem
  onAdd: (filter: BeneficiaryFilterItem) => void
}

export default function NewFilterForm(props: NewFilterFormProps) {
  const { schemaItem, onAdd } = props

  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div className="h-full w-full text-sm capitalize">{schemaItem.label}</div>
      </PopoverTrigger>
      <PopoverContent side="right" align="start" className="w-full">
        {schemaItem.type === 'string' && (
          <StringFilterForm
            onChange={onAdd}
            onCancel={() => setOpen(false)}
            filter={buildStringFilter(schemaItem)}
          />
        )}
        {schemaItem.type === 'number' && (
          <NumberFilterForm
            onChange={onAdd}
            onCancel={() => setOpen(false)}
            filter={buildNumberFilter(schemaItem)}
          />
        )}
        {schemaItem.type === 'boolean' && (
          <BooleanFilterForm
            onChange={onAdd}
            onCancel={() => setOpen(false)}
            filter={buildBooleanFilter(schemaItem)}
          />
        )}
        {schemaItem.type === 'enum' && (
          <EnumFilterForm
            schemaItem={schemaItem}
            onChange={onAdd}
            onCancel={() => setOpen(false)}
            filter={buildEnumFilter(schemaItem)}
          />
        )}
        {schemaItem.type === 'multiselect' && (
          <MultiselectFilterForm
            schemaItem={schemaItem}
            onChange={onAdd}
            onCancel={() => setOpen(false)}
            filter={buildMultiselectFilter(schemaItem)}
          />
        )}
        {schemaItem.type === 'date' && (
          <DateFilterForm
            onChange={onAdd}
            onCancel={() => setOpen(false)}
            filter={buildDateFilter(schemaItem)}
          />
        )}
      </PopoverContent>
    </Popover>
  )
}
